import { useQueryClient } from '@tanstack/react-query';
import { actionListQueryOptions } from '@/modules/FileDetail/queries/actionList/actionListQueryOptions';
import { alertsQueryOptions } from '@/modules/FileDetail/queries/alerts/alertsQueryOptions';
import { entryTabsQueryOptions } from '@/modules/FileDetail/queries/entryTabs/entryTabsQueryOptions';
import { fileEntryQueryOptions } from '@/modules/FileDetail/queries/fileEntry/fileEntryQueryOptions';

const useRevalidateFileDetail = (id: string) => {
  const queryClient = useQueryClient();

  const revalidateFileDetail = () => {
    return Promise.all([
      queryClient.invalidateQueries({
        queryKey: actionListQueryOptions(id).queryKey,
      }),
      queryClient.invalidateQueries({
        queryKey: fileEntryQueryOptions(id).queryKey,
      }),
      queryClient.invalidateQueries({
        queryKey: alertsQueryOptions(id).queryKey,
      }),
      queryClient.invalidateQueries({
        queryKey: entryTabsQueryOptions(id).queryKey,
      }),
    ]);
  };

  return { revalidateFileDetail };
};

export default useRevalidateFileDetail;
